import React from 'react'
import { Helmet } from 'react-helmet'
import { isDev } from '../../../helpers'
import { withParsedContext } from '../../Magazines/withJSSContext'

interface Props {
  parsedFields: {
    IsConfigurable: boolean
    ConfigurableAssetsRootUrl: string
  }
  parsedSitecoreContext: {
    language: string
  }
}
const HeadScripts: React.FC<Props> = ({ parsedFields }) => {
  const isConfigurable = parsedFields?.IsConfigurable || isDev
  const configurableAssetsRootUrl = parsedFields?.ConfigurableAssetsRootUrl

  const arizonaCssUrl = isConfigurable && `${configurableAssetsRootUrl}/arizona.css`

  const designSystemLibraryEsmUrl =
    isConfigurable && `${configurableAssetsRootUrl}/christies-design-system-library.esm.js`
  const designSystemLibraryUrl = isConfigurable && `${configurableAssetsRootUrl}/christies-design-system-library.js`
  const designSystemLibraryCssHeaderFooter =
    isConfigurable && `${configurableAssetsRootUrl}/christies-design-system-library-header-footer.css`

  return (
    <Helmet>
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
      <meta name="format-detection" content="telephone=no" />

      {arizonaCssUrl ? <link href={arizonaCssUrl} rel="stylesheet" /> : null}
      {designSystemLibraryEsmUrl ? <script type="module" src={designSystemLibraryEsmUrl}></script> : null}
      {designSystemLibraryUrl ? <script noModule src={designSystemLibraryUrl}></script> : null}
      {designSystemLibraryCssHeaderFooter ? <link rel="stylesheet" href={designSystemLibraryCssHeaderFooter} /> : null}

      <script type="text/javascript">
        {
          /* js */ `
              function getRootNode(o) { return "object" == typeof o && Boolean(o.composed) ? getShadowIncludingRoot(this) : getRoot(this) } function getShadowIncludingRoot(o) { var t = getRoot(o); return isShadowRoot(t) ? getShadowIncludingRoot(t.host) : t } function getRoot(o) { return null != o.parentNode ? getRoot(o.parentNode) : o }
              function isShadowRoot(o) { return "#document-fragment" === o.nodeName && "ShadowRoot" === o.constructor.name } Object.defineProperty(Node.prototype, "getRootNode", {enumerable: !1, configurable: !1, value: getRootNode });
`
        }
      </script>
    </Helmet>
  )
}
export default withParsedContext(HeadScripts as React.FC)
